import { render, staticRenderFns } from "./BindUsdt.vue?vue&type=template&id=dcb121a8&scoped=true"
import script from "./BindUsdt.vue?vue&type=script&lang=js"
export * from "./BindUsdt.vue?vue&type=script&lang=js"
import style0 from "./BindUsdt.vue?vue&type=style&index=0&id=dcb121a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb121a8",
  null
  
)

export default component.exports